export default "__VITE_ASSET__DirB5qjW__"